import { CreateEditController, CreateEditScope } from "../../common/common.create-edit.controller"
import { LoggerService } from "../../common/common.module"
import { CreateEditInitParams, BulkEditInitParams } from "../../common/create-edit-popup/create-edit-popup.controller"

import { IUserSession, EventsNames, LocalizationHelper, CommonHelper } from "../../../helpers"
import { PopupType } from "../../../helpers/popup-manager"

import { Enums } from "../../../models/common"
import { OpOperatorGroup } from "../../../models/core"
import { IOpObject } from "../../../models/util/interfaces"

import { OperatorGroupHelper } from "../operator-group-helper"

interface OperatorCreateEditScope extends CreateEditScope { }

export class OperatorGroupCreateEditController extends CreateEditController {

    // #region Members

    private referenceValue: OpOperatorGroup

    // #endregion


    // #region Ctor

    constructor(
        private $scope: OperatorCreateEditScope,
        private $q: ng.IQService,
        private $timeout: ng.ITimeoutService,
        private logger: LoggerService,
        protected userSession: IUserSession,
        private referenctType: Enums.ReferenceType,
        private moduleName: Enums.SimaxModuleName
    ) {
        super(referenctType)

        this.setEvents()
        this.setOptions()
    }

    // #endregion


    // #region Setup

    private setEvents() {
        this.$scope.$on(
            EventsNames.getEventNameByModule(Enums.SimaxEventCategory._MODULE_NAME__OPEN_CREATE_EDIT_POPUP, this.moduleName),
            (event: ng.IAngularEvent, ...args: any[]) => this.onInit(args)
        )

        this.$scope.$on(
            EventsNames.getEventNameByModule(Enums.SimaxEventCategory._MODULE_NAME__OPEN_BULK_EDIT_POPUP, this.moduleName),
            (event: ng.IAngularEvent, ...args: any[]) => this.onInitBulk(args)
        )
    }


    private setOptions() {
        this.$scope.popupVisible = false
        this.$scope.options = {
            localStorageVarForSavedEntity: CommonHelper.localStorageVarForSavedEntity.operatorGroupSaved,
            onSubmit: null,
            onClose: null,
            referenceType: this.referenceType,
            submitBulkEdit: null,
            succsessMessage: LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__SAVED, this.moduleName),
            title: '',
            type: null,

            onBulkSave: (objectToSave: IOpObject) => this.onBulkSave(objectToSave),
            onSave: (objectToSave: IOpObject) => this.onSave(objectToSave),
        }
    }

    // #endregion


    // #region Events

    private onInit(args: any[]) {
        if (args && args[0]) {
            const createEditInitParams: CreateEditInitParams = args[0]

            this.referenceValue = createEditInitParams ? <OpOperatorGroup>createEditInitParams.referenceObject : null
            this.$scope.$broadcast(EventsNames.SHOW_CREATE_EDIT_POPUP, PopupType.CREATE_EDIT_POPUP)

            if (this.referenceValue && this.referenceValue.idObject > 0) {
                this.$scope.options.title = LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__EDITING, this.moduleName)
            } else {
                this.$scope.options.title = LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__ADDING, this.moduleName)
            }

            this.$timeout(() => {
                this.$scope.$broadcast(EventsNames.OPEN_CREATE_EDIT_POPUP, createEditInitParams)
            })
        }
    }

    private onInitBulk(args: any[]) {
        if (args && args[0]) {
            const bulkEditInitParams: BulkEditInitParams = args[0]
            this.$scope.$broadcast(EventsNames.SHOW_CREATE_EDIT_POPUP, PopupType.BULK_EDIT_POPUP)
            this.$scope.options.title = LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__MASS_EDITING, this.moduleName)
            this.$scope.gridData = args[0]
            if (args && args[1]) {
                this.$scope.gridColumns = args[1]
            }

            this.$scope.$broadcast(EventsNames.OPEN_BULK_EDIT_POPUP, bulkEditInitParams)
        }
    }

    private onSave(objectToSave: IOpObject): ng.IPromise<IOpObject> {
        const deferred = this.$q.defer<IOpObject>()
        const groupToSave: OpOperatorGroup = OpOperatorGroup.fromIOpObject(objectToSave)

        OperatorGroupHelper
            .saveOperatorGroup(this.userSession.getDataProvider(), groupToSave, this.moduleName)
            .then((savedObject: OpOperatorGroup) => {
                this.$scope.$root.$broadcast(EventsNames.CLOSE_CREATE_EDIT_POPUP, savedObject)

                deferred.resolve(savedObject)
            }).fail((error: any) => {
                this.logger.log(error)
                deferred.reject(error)
            })

        return deferred.promise
    }

    private onBulkSave(objectToSave: IOpObject): ng.IPromise<IOpObject> {
        const deferred = this.$q.defer<IOpObject>()
        const groupToSave: OpOperatorGroup = OpOperatorGroup.fromIOpObject(objectToSave)

        groupToSave.opState = Enums.OpChangeState.Modified

        OperatorGroupHelper
            .saveOperatorGroup(this.userSession.getDataProvider(), groupToSave, this.moduleName, true)
            .then((savedObject: OpOperatorGroup) => {
                deferred.resolve(savedObject)
            }).fail((error: any) => {
                this.logger.log(error)
                deferred.reject(error)
            })

        return deferred.promise
    }

    // #endregion
}